import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useToast } from "@/hooks/use-toast";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { toast } = useToast();

  useEffect(() => {
    // Only redirect if we've finished loading and the user is not authenticated
    if (!isLoading && !isAuthenticated) {
      // 检查是否直接访问登录页面，避免显示错误提示
      const comingFromLogin = location.pathname === '/login';
      const hasLoginReferrer = document.referrer.includes('/login');
      
      // 只有当不是直接访问登录页面时才显示提示
      if (!comingFromLogin && !hasLoginReferrer) {
        toast({
          title: "Authentication required",
          description: "Please log in to access this page",
          variant: "destructive",
        });
      }
      
      navigate("/login", { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate, toast, location]);

  // Show loading state only while we're checking authentication
  if (isLoading) {
    return (
      <div className="h-screen w-full flex items-center justify-center bg-black">
        <div className="animate-pulse text-anzir text-xl">Loading...</div>
      </div>
    );
  }

  // If we're authenticated, render the children
  return isAuthenticated ? <>{children}</> : null;
};

export default ProtectedRoute;
